import { isPriorityOrderActive } from "@/lib/priorityOrder";
import { useDriverLangMaybe } from "@/context/DriverLanguageContext";

export default function PriorityOrderBanner({ order, className = "", active }) {
  const driverLang = useDriverLangMaybe();
  const show = active != null ? active : isPriorityOrderActive(order);
  if (!show) return null;

  const title = driverLang?.t("priorityTitle") ?? "⚡ PRIORITY ORDER";
  const hint =
    driverLang?.t("priorityHint") ??
    "Customer needs this immediately — finish before other orders";

  return (
    <div
      className={`rounded-2xl border-2 border-green-600 bg-gradient-to-r from-green-200 to-green-300 px-4 py-3 text-center shadow-sm ${className}`}
      data-testid="priority-order-banner"
    >
      <p className="text-base font-extrabold tracking-wide text-green-900 sm:text-lg">{title}</p>
      <p className="mt-0.5 text-xs font-semibold text-green-800 sm:text-sm">{hint}</p>
    </div>
  );
}
